import { ShieldCheck, LogIn } from "lucide-react";
import OtpLogin from "@/components/OtpLogin";
import { useOpenDestination } from "@/lib/signIn";
import { TEST_NUMBERS } from "@/lib/testAccounts";

/**
 * The platform's own sign-in: /super/login and /login. It is not tied to one
 * tenant, so the number is offered every account it has: Super Admin, and each
 * tenant it is an admin, seller or customer of. On /super/login a Super Admin's
 * number goes straight to the Super Admin console.
 */
export default function SuperLogin({ general = false }) {
  const open = useOpenDestination();

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] admin-body p-4 sm:p-6">
      <div className="w-full max-w-md bg-white border border-neutral-200 rounded-none p-6 sm:p-8" data-testid="super-login-card">
        <div className="flex items-center gap-2 mb-1">
          {general ? <LogIn className="h-5 w-5 text-black" /> : <ShieldCheck className="h-5 w-5 text-black" />}
          <div className="admin-overline">{general ? "LocalAppStore" : "Super Admin / Owner"}</div>
        </div>
        <h1 className="admin-heading text-3xl sm:text-4xl font-bold tracking-tight">{general ? "Sign in." : "Control center."}</h1>
        <p className="text-sm text-neutral-500 mt-2">
          {general
            ? "Enter your mobile number. We take you to what that number can open: the platform, a business you manage, or your customer account."
            : "Sign in with your mobile number to manage all tenants, plans & platform."}
        </p>
        <div className="mt-8">
          <OtpLogin prefer={general ? undefined : "super_admin"} look="console" testid="super-login" onSignedIn={(session) => open(session)} testNumbers={TEST_NUMBERS} />
        </div>
      </div>
    </div>
  );
}
